import { render, staticRenderFns } from "./OrganizationInvoices.vue?vue&type=template&id=699b2f45"
import script from "./OrganizationInvoices.vue?vue&type=script&lang=js"
export * from "./OrganizationInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports